<template>
  <configurator ref="configurator" v-bind:p_configuratorSettings="configuratorSettings" v-bind:p_configuratorName="p_configuratorName" v-bind:p_configuratorId="p_configuratorId" v-bind:p_configuratorDomain="p_configuratorDomain" v-bind:p_logoUrl="logoUrl" v-bind:p_randomFacts="randomFactsString"/>
</template>

<script>
import axios from 'axios';
import Configurator from '../../components/configurator/Configurator';

const urlLoadScreenRest = process.env.URL_BACKEND + process.env.REST_LOAD_SCREEN_READ_LOAD_SCREEN;
const urlReadConfiguratorSettingsRest = process.env.URL_BACKEND + process.env.REST_CONFIGURATOR_SETTING_READ_CONFIGURATOR_SETTINGS;

export default {
  name: 'ConfiguratorView',
  props: {
    p_configuratorId: Number,
    p_configuratorName: String,
    p_configuratorDomain: String,
  },
  components: {
    Configurator,
  },
  data() {
    return {
      configuratorId: this.p_configuratorId,
      logoUrl: '',
      randomFactsString: '',
      configuratorSettings: [],
    };
  },
  created() {
    // Call REST readloadscreen
    let json = JSON.stringify({ affectedLoadScreen: { configurator_id: this.configuratorId } });
    axios.post(urlLoadScreenRest, json, {
      headers: {
      // Overwrite Axios's automatically set Content-Type
        'Content-Type': 'application/json',
      },
    }).then((result) => {
      this.logoUrl = process.env.URL_BACKEND + result.data.type;
      this.randomFactsString = result.data.random_facts;
    });

    // Call REST readconfiguratorsettings
    json = JSON.stringify({ configurator: { id: this.configuratorId } });
    axios.post(urlReadConfiguratorSettingsRest, json, {
      headers: {
      // Overwrite Axios's automatically set Content-Type
        'Content-Type': 'application/json',
      },
    }).then((result) => {
      // Create custom css file with all
      let cssScript = document.createElement("style");
      cssScript.innerHTML = '';
      result.data.forEach((element) => {
        this.configuratorSettings.push({
          name: element.name,
          css_label: element.css_label,
          value: element.value,
        });
        if (element.css_label != null) {
          element.css_label.split(';').forEach((cssLabelElement) => {
            cssScript.innerHTML += '.'+cssLabelElement.trim()+'{';
            // The values are seperated with ';'
            element.value.split(';').forEach((valueElement) => {
              cssScript.innerHTML += valueElement+';';
            });
            cssScript.innerHTML += '} ';
          });
        }
      });
      document.head.appendChild(cssScript);
    }).finally(() => {
      // TODO: Duschking special
      this.$store.commit('deleteSpecificStep',  -50);
      this.$store.commit('addStepValue', {stepId:-50, stepIndex:-50, attributeId: -50, value: "EK"});
      this.$refs['configurator'].initializeHelpSettings();
    });
  },
};
</script>

<style language="css">
  @import '../../assets/magnific-popup-1.1.0/magnific-popup.css';
</style>


// WEBPACK FOOTER //
// src/views/configurator/ConfiguratorView.vue